import { render } from "./UnluUyumu.vue?vue&type=template&id=3941788e"
import script from "./UnluUyumu.vue?vue&type=script&lang=js"
export * from "./UnluUyumu.vue?vue&type=script&lang=js"

import "./UnluUyumu.vue?vue&type=style&index=0&id=3941788e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__